module.exports = __webpack_public_path__ + "img/40_69_011_920.23bc3cc8.jpg";